<div class="slider-container">
    <div class="slider-label" trans>Opacity</div>
    <mat-slider min="0.1" max="1" step="0.1" [formControl]="activeObject.form.get('opacity')"></mat-slider>
</div>